import { GoogleOAuthProvider } from "@react-oauth/google";
import { getClientId } from "@/utils/configAlt";
const GoogleAuthWrapper = ({ children }) => {
  const clientId = getClientId();
  if (!clientId) {
    return children;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>
  );
};

export default GoogleAuthWrapper;
